export default __webpack_public_path__ + "static/media/icon_audio_loading_mobile.db1e71e6.svg";